var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 30,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7761 27.2878C20.6441 27.2878 17.7401 27.2878 16.4201 27.2878C15.7161 27.2878 15.4961 27.0238 15.4961 26.3638C15.4961 24.6038 15.4961 22.7998 15.4961 21.0398C15.4961 20.3358 15.7601 20.1158 16.4201 20.1158H20.7761C20.7761 19.9838 20.7761 17.4318 20.7761 16.2438C20.7761 14.4838 21.0841 12.8118 21.9641 11.2718C22.8881 9.68785 24.2081 8.63185 25.8801 8.01585C26.9801 7.61985 28.0801 7.44385 29.2681 7.44385H33.5801C34.1961 7.44385 34.4601 7.70785 34.4601 8.32385V13.3398C34.4601 13.9558 34.1961 14.2198 33.5801 14.2198C32.3921 14.2198 31.2041 14.2198 30.0161 14.2638C28.8281 14.2638 28.2121 14.8358 28.2121 16.0678C28.1681 17.3878 28.2121 18.6638 28.2121 20.0278H33.3161C34.0201 20.0278 34.2841 20.2918 34.2841 20.9958V26.3198C34.2841 27.0238 34.0641 27.2438 33.3161 27.2438C31.7321 27.2438 28.3441 27.2438 28.2121 27.2438V41.5878C28.2121 42.3358 27.9921 42.5999 27.2001 42.5999C25.3521 42.5999 23.5481 42.5999 21.7001 42.5999C21.0401 42.5999 20.7761 42.3359 20.7761 41.6759C20.7761 37.0559 20.7761 27.4198 20.7761 27.2878Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e2f0f63a429870813f6d3fa791214aa6.svg";
export { ForwardRef as ReactComponent };